import styled from 'styled-components';

export const BodyWrapper = styled.div`
  max-width: 100%;
  height: 100%;
  margin-top: 80px;
  margin-left: 16px;
  margin-right: 16px;
  position: relative;
`;
